var lastScrollTop = 0;

function resizeWindow(){
	setTimeout(function() {
		equalize();
	}, 500);
}
function scrollDown(){

}

$(document).ready(function () {

	//Call function with browser is resized.
    $(window).resize(function (event) {
         resizeWindow();
    });
    resizeWindow();

    //Acts when scroll down page.
    $(window).scroll(function (event) {
    	scrollDown();
		var top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	});

	if($("#default > div.topalert")){
		$("#content > div > div > div > div").addClass("top-alert");
	}
	if($('#home').length > 0) {
		$('.top-content-home').fullscreenBackground();
	}
	
	$('.read-more').click(function(e) {
	    $(this).parent().next('div.full-intro').slideToggle();
	    var text = $(this).text();
		$(this).text(text == "Show Less" ? "Read More" : "Show Less");
	});
	
	$('.learn-events').click(function(e) {
	    $(this).next('div.full-event').slideToggle();
	});

	$('.request-info').click(function(e) {
	    $('.form-box').fadeIn();
	});
	$('.processForm').click(function(e) {
	    $('#formRFP').submit();
	});

	//pop in hardcoded
	$('.special-popin__call').click(function () {
		$('.special-popin__content').addClass('active');
	});
	$('.special-popin__content .closepopin').click(function () {
		$('.special-popin__content').removeClass('active');
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function(event) {
	    $('body, html').animate({
	        scrollTop: $(window).height()-$('header').outerHeight()*2},
	        800, 'easeOutExpo');
	});

	//Event Tracking
    $('.book-now').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
    });
    $('.bookNow').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
    });

	//Check in and check out datepicker for booking engine
	$( "#CheckIn" ).datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			getDate = $(this).datepicker('getDate');
        	newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut" ).datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
	
	$('.fancylink').fancybox({
		//Avoids page scroll jump on click
		afterShow: function () {
	  	//alert('hello');
	  	$(".popup-text").niceScroll({
	  		cursorcolor:"#f15c30",
				cursorwidth:"10px",
				background:"#013474",
				cursorborderradius:0,
				cursorborder:'none',
				cursoropacitymin:1,
				autohidemode:false
	  	});
	  },
	  helpers: {
	    overlay: {
	      locked: false
	    }
	  },
	  padding:0,


	});


	//mobile position change
	if($(window).width() < 600){
		$('.mobile-dining').insertBefore($('.mobile-card'));
		$('footer .address').insertAfter($('.address-pin p'));
	}
	
	/*--
	$('#external-men #clickmenu').click(function() {
		$( "#menusContainer" ).css("height", "auto");
	});
	
	$('#external-men .close-btn').click(function() {
		$( "#menusContainer" ).css("height", "0");
		return false;
	});
	--*/

	$('#menu h2').click(function() {
		$( "#menusContainer" ).css("height", "auto");
	});
	
	$('#menu .close-btn').click(function() {
		$( "#menusContainer" ).css("height", "0");
		return false;
	});
	
	// Map: Return to previous page button. Change body id to match map template's name.
	//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	$('.request-info').click(function(event){
		event.preventDefault();
		$('#rfp-bd').slideToggle();
	})


	// Remove atr
		$('#third-nav').removeAttr('aria-labelledby');
		$('#third-nav').removeAttr('aria-label');
});


function navisEmailSignup(formID) {

	$.post(site_url + 'ajax/email-signup.php',$("#" + formID).serialize(), function(data){
		if(data.error) {
			if (formID == 'email-signup2')
				$("#email-error2").html(data.msg);
			else
				$("#email-error").html(data.msg);

		} else {
			//ga('send', 'event', 'form', 'click', 'specials');
			$("#"+formID).html('<p>Thank You</p>');

		}
	},'json');

}

$(window).on('load', function(){

   	//Slick Slider
	$('.sym-slides').slick();

	scrollW();
	window.addEventListener('scroll', function(){
		scrollW();
	})
	
});

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

(function() {
	if (document.getElementById("ot-sdk-btn") && document.getElementById("tertiary-navigation")) {
        document.getElementById("tertiary-navigation").appendChild(document.getElementById("ot-sdk-btn"))
    }
})();